module.exports = __webpack_public_path__ + "img/pic37.3c8c79e7.png";